import { useEffect } from "react";

const SITE_URL = "https://dmo-tech.ro";

const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

// Setează title + meta description + Open Graph + canonical + (opțional) JSON-LD pentru SEO.
export const useSeo = ({ title, description, image, url, jsonLd }) => {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;

    // Canonical — mereu pe domeniul de producție, fără query/hash (evită „dublură fără canonică").
    const path = typeof window !== "undefined" ? window.location.pathname : "/";
    const canonical = url || SITE_URL + path;
    let linkEl = document.head.querySelector('link[rel="canonical"]');
    const prevCanonical = linkEl ? linkEl.getAttribute("href") : null;
    if (!linkEl) {
      linkEl = document.createElement("link");
      linkEl.setAttribute("rel", "canonical");
      document.head.appendChild(linkEl);
    }
    linkEl.setAttribute("href", canonical);

    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", jsonLd ? "article" : "website");
    if (image) setMeta("property", "og:image", image);
    setMeta("property", "og:url", canonical);
    setMeta("name", "twitter:card", "summary_large_image");

    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo-jsonld", "1");
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => {
      document.title = prevTitle;
      if (script) script.remove();
      if (linkEl && prevCanonical !== null) linkEl.setAttribute("href", prevCanonical);
    };
  }, [title, description, image, url, jsonLd]);
};
